import { useState } from 'react';

const ModuleSection = ()=>{
    const [ openElement, setOpenElement ] = useState(false);

    const handleClickElement = ()=>{ setOpenElement(!openElement) };

    return [ openElement, handleClickElement ];
};

export default ModuleSection;